//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CesHttpClient, Continuum } from "../CesHttpClient";

export default {
  data: function () {
    return {
      cesModel: null
    };
  },
  mounted: function () {
    //console.log('Mounted !!')
  },
  computed: {
    showPlannedWell: {
      get() {
        return this.$store.state.preferences.global.showPlannedWell;
      },
      set(value) {
        this.$store.commit("preferences/updateShowPlannedWell", value);
      }
    },
    showImageLog: {
      get() {
        return this.$store.state.preferences.showImageLog;
      },
      set(value) {
        this.$store.commit("preferences/updateShowImageLog", value);
      }
    },
    showInformationView: {
      get() {
        return this.$store.state.preferences.global.showInformationView;
      },
      set(value) {
        this.$store.commit("preferences/updateShowInformationView", value);
      }
    },
    showStatusBar: {
      get() {
        return this.$store.state.preferences.global.showStatusBar;
      },
      set(value) {
        this.$store.commit("preferences/updateShowStatusBar", value);
      }
    },
    showDecisionPoints: {
      get() {
        return this.$store.state.preferences.vtk3DView.showDecisionPoints;
      },
      set(value) {
        this.$store.commit("preferences/updateShowDecisionPoints", value);
      }
    },
    showDrilledPath: {
      get() {
        return this.$store.state.preferences.vtk3DView.showDrilledPath;
      },
      set(value) {
        this.$store.commit("preferences/updateShowDrilledPath", value);
      }
    },
    showGrid: {
      get() {
        return this.$store.state.preferences.vtk3DView.showGrid;
      },
      set(value) {
        this.$store.commit("preferences/updateShowGrid", value);
      }
    }
  },
  methods: {
    init: function () {
      //console.log('Init !!')
    },
    cleanLocalStorageCache: async function() {
      try {
        // TODO: add local storage name.
        await this.$vlf.dropInstance()
        alert('Clean cache success!')
      } catch (err) {
        alert('Clean cache failed!')
      }
    }
  }
};
